import { render, staticRenderFns } from "./DriverInfoTopNew.vue?vue&type=template&id=c22cb216&scoped=true"
import script from "./DriverInfoTopNew.vue?vue&type=script&lang=js"
export * from "./DriverInfoTopNew.vue?vue&type=script&lang=js"
import style0 from "./DriverInfoTopNew.vue?vue&type=style&index=0&id=c22cb216&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c22cb216",
  null
  
)

export default component.exports